import React from "react";

interface CommandCenterMapContainerProps {
    children?: React.ReactNode;
}

// This container is intended to wrap the map and related controls for the Jobsite Command dashboard.
const CommandCenterMapContainer: React.FC<CommandCenterMapContainerProps> = ({ children }) => {
    return <div className="flex flex-col flex-1 min-h-0 rounded-lg overflow-hidden">{children}</div>;
};

export default CommandCenterMapContainer;
